module.exports = __webpack_public_path__ + "img/logo_full_white.809c9d55.png";